import "./index.css";

import App from "./App";
import React from "react";
import ReactDOM from "react-dom/client";

// Set custom cursor for all elements - apply immediately and on DOM ready
const applyCustomCursor = () => {
  const cursorStyle = `
    html, body, * {
      cursor: url('/click-4.png') 5 5, auto !important;
    }
    a, button, [role="button"], div[onClick], input, textarea, select {
      cursor: url('/click-4.png') 5 5, auto !important;
    }
  `;
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = cursorStyle;
  styleSheet.id = "custom-cursor-style";
  
  // Remove existing style if present
  const existingStyle = document.getElementById("custom-cursor-style");
  if (existingStyle) {
    existingStyle.remove();
  }
  
  document.head.appendChild(styleSheet);
  
  // Also set directly on html and body elements if they exist
  if (document.documentElement) {
    document.documentElement.style.cursor = "url('/click-4.png') 5 5, auto";
  }
  if (document.body) {
    document.body.style.cursor = "url('/click-4.png') 5 5, auto";
  }
};

// Apply immediately
applyCustomCursor();

// Also apply when DOM is ready (in case body/html isn't ready yet)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', applyCustomCursor);
} else {
  // DOM is already ready
  applyCustomCursor();
}

// render application
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
